var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginAsAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1458893,11.4285714 C14.5466003,11.4285714 16.5,13.4580776 16.5,15.9523228 L16.5,15.9523228 L16.5,19.2857143 C16.5,19.6800014 16.1920013,20 15.8125,20 L15.8125,20 L0.6875,20 C0.307998668,20 0,19.6800014 0,19.2857143 L0,19.2857143 L0,15.9523228 C0,13.4580776 1.95339968,11.4285714 4.35411071,11.4285714 L4.35411071,11.4285714 Z M18.1051178,4.76283482 C18.2746429,4.76283482 18.4433288,4.8275321 18.5725708,4.95239259 L18.5725708,4.95239259 L21.7809601,8.04757254 C21.9202728,8.18289621 22,8.37332589 22,8.57142857 C22,8.76953125 21.9202728,8.95996094 21.7809601,9.0952846 L21.7809601,9.0952846 L18.5725708,12.1904646 C18.4424896,12.315325 18.2746429,12.3808942 18.1041107,12.3808942 C17.7264557,12.3808942 17.4166107,12.0628139 17.4166107,11.6666085 L17.4166107,11.6666085 L17.4166107,9.52375138 L13.75,9.52375138 C13.243103,9.52375138 12.8333893,9.09720286 12.8333893,8.57142857 C12.8333893,8.04565429 13.243103,7.61910576 13.75,7.61910576 L13.75,7.61910576 L17.4166107,7.61910576 L17.4166107,5.47624862 C17.4166107,5.16479491 17.6504212,4.76283482 18.1051178,4.76283482 Z M8.25,-6.21724894e-15 C10.7812958,-6.21724894e-15 12.8333893,2.13204518 12.8333893,4.7619629 C12.8333893,7.39188058 10.7812958,9.52375138 8.25,9.52375138 C5.71870423,9.52375138 3.66661071,7.39188058 3.66661071,4.7619629 C3.66661071,2.13204518 5.71870423,-6.21724894e-15 8.25,-6.21724894e-15 Z",
    id: "Combined-Shape",
    fill: "#8F9BA9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginAsAdmin);
export default __webpack_public_path__ + "static/media/LoginAsAdmin.e68f1411418266551198a16725fd4ea8.svg";
export { ForwardRef as ReactComponent };